import { clowncar } from 'types';

import ClowncarAppConstants from 'constants/ClowncarAppConstants';

import protos from 'utils/protos';

const { SubscriptionPlan, SubscriptionPlanAddon } = protos;

export function addSubscriptionPlan(
  subscription: clowncar.SubscriptionPlan
): ApiAction<clowncar.SubscriptionPlan> {
  return {
    TockApi: {
      postProto: '/internal/subscription/plan',
      request: SubscriptionPlan.fromObject(subscription),
      type: ClowncarAppConstants.SUBSCRIPTION_PLAN_ADD,
      toast: `Added subscription plan ${subscription.name}`,
    },
  };
}

export function addSubscriptionPlanAddon(
  addon: clowncar.SubscriptionPlanAddon
): ApiAction<clowncar.SubscriptionPlanAddon> {
  return {
    TockApi: {
      postProto: '/internal/subscription/plan/addon',
      request: SubscriptionPlanAddon.fromObject(addon),
      type: ClowncarAppConstants.SUBSCRIPTION_ADDON_ADD,
      toast: `Added subscription plan addon ${addon.name}`,
    },
  };
}
